import React from 'react';

export default function ErrorMessage({ message }) {
    return (
        <div className="app-error-message">
            <p>Error: {message}</p>
        </div>
    );
}
